import {action, makeObservable, observable, runInAction} from "mobx";
import app from "../app.js";
import {outSyncHandler, Sync} from "../sync/index.js";
import {Store} from "./index.js";
import {fetchLockOptions} from "./common.js";
import AsyncLock from "async-lock";
import type {appConfig} from "../model/index.js";

// TODO: expire/refresh after some time

export class AppConfigStore implements Store {
	config: appConfig = {};
	_fetchLock = new AsyncLock(fetchLockOptions);

	constructor() {
		makeObservable(this, {
			config: observable,
			_clear: action
		});
	}

	_clear() {
		this.config = {};
	}

	async _fetch(force = false) {
		await this._fetchLock.acquire("_fetch", async () => {
			if (!app.backend)
				return;
			const config = await app.backend.getAppConfig();
			runInAction(() => {
				this.config = config;
			});
		});
	}

	_setupSyncHandlers(sync: Sync) {
	}

	_setupOutSyncHandlers(handler: outSyncHandler) {

	}

	_refresh(): void {
		// noinspection JSIgnoredPromiseFromCall
		this._fetch(true);
	}
}

export default new AppConfigStore();
